import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { useLanguage } from '../hooks/useLanguage';
export function PrivacyPolicyPage() {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  return <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-2575">
      <Navbar data-id="element-2576" />

      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-2577">
        <Link to="/" className="inline-flex items-center gap-2 text-[#4f1964] hover:text-[#3d1350] mb-8 transition-colors" data-id="element-2578">
          <ArrowLeft className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} data-id="element-2579" />
          <span data-id="element-2580">{isRTL ? 'العودة للرئيسية' : 'Back to Home'}</span>
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-2581">
          <div className="flex items-center gap-4 mb-8" data-id="element-2582">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-2583">
              <Shield className="w-8 h-8 text-[#4f1964]" data-id="element-2584" />
            </div>
            <div data-id="element-2585">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-2586">
                {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-2587">
                {isRTL ? 'آخر تحديث: يناير 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-2588">
            {isRTL ? <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2589">
                  مقدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2590">
                  في Operines، نحن ملتزمون بحماية خصوصيتك وأمان بياناتك. توضح
                  سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك الشخصية
                  عند استخدام منصتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2591">
                  المعلومات التي نجمعها
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2592">
                  نقوم بجمع الأنواع التالية من المعلومات:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2593">
                  <li data-id="element-2594">معلومات الحساب: الاسم، البريد الإلكتروني، رقم الهاتف</li>
                  <li data-id="element-2595">معلومات الأعمال: اسم النشاط التجاري، الفئة، الوصف</li>
                  <li data-id="element-2596">بيانات الاستخدام: كيفية تفاعلك مع منصتنا</li>
                  <li data-id="element-2597">معلومات تقنية: عنوان IP، نوع المتصفح، نظام التشغيل</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2598">
                  كيف نستخدم معلوماتك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2599">
                  نستخدم معلوماتك من أجل:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2600">
                  <li data-id="element-2601">تقديم وتحسين خدماتنا</li>
                  <li data-id="element-2602">التواصل معك بشأن حسابك والتحديثات</li>
                  <li data-id="element-2603">معالجة المعاملات والفواتير</li>
                  <li data-id="element-2604">تخصيص تجربتك</li>
                  <li data-id="element-2605">ضمان أمان المنصة ومنع الاحتيال</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2606">
                  مشاركة البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2607">
                  نحن لا نبيع معلوماتك الشخصية. قد نشارك بياناتك مع مزودي خدمات
                  موثوقين يساعدوننا في تشغيل منصتنا، مثل خدمات الاستضافة ومعالجة
                  الدفع، وذلك فقط بالقدر اللازم لتقديم خدماتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2608">
                  أمان البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2609">
                  نستخدم تدابير أمنية متقدمة لحماية معلوماتك، بما في ذلك التشفير
                  والتخزين الآمن وضوابط الوصول. ومع ذلك، لا يمكن لأي طريقة نقل
                  عبر الإنترنت أن تكون آمنة بنسبة 100%.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2610">
                  حقوقك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2611">
                  لديك الحق في:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2612">
                  <li data-id="element-2613">الوصول إلى بياناتك الشخصية</li>
                  <li data-id="element-2614">تصحيح المعلومات غير الدقيقة</li>
                  <li data-id="element-2615">طلب حذف بياناتك</li>
                  <li data-id="element-2616">الاعتراض على معالجة بياناتك</li>
                  <li data-id="element-2617">طلب نقل البيانات</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2618">
                  الاتصال بنا
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2619">
                  إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال
                  بنا على:
                  <br data-id="element-2620" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2621">
                    hello@operines.ai
                  </a>
                </p>
              </> : <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2622">
                  Introduction
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2623">
                  At Operines, we are committed to protecting your privacy and
                  securing your data. This Privacy Policy explains how we
                  collect, use, and safeguard your personal information when you
                  use our platform.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2624">
                  Information We Collect
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2625">
                  We collect the following types of information:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2626">
                  <li data-id="element-2627">Account Information: Name, email, phone number</li>
                  <li data-id="element-2628">
                    Business Information: Business name, category, description
                  </li>
                  <li data-id="element-2629">Usage Data: How you interact with our platform</li>
                  <li data-id="element-2630">
                    Technical Information: IP address, browser type, operating
                    system
                  </li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2631">
                  How We Use Your Information
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2632">
                  We use your information to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2633">
                  <li data-id="element-2634">Provide and improve our services</li>
                  <li data-id="element-2635">Communicate with you about your account and updates</li>
                  <li data-id="element-2636">Process transactions and billing</li>
                  <li data-id="element-2637">Personalize your experience</li>
                  <li data-id="element-2638">Ensure platform security and prevent fraud</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2639">
                  Data Sharing
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2640">
                  We do not sell your personal information. We may share your
                  data with trusted service providers who help us operate our
                  platform, such as hosting and payment processing services,
                  only to the extent necessary to provide our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2641">
                  Data Security
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2642">
                  We use industry-standard security measures to protect your
                  information, including encryption, secure storage, and access
                  controls. However, no method of transmission over the internet
                  can be 100% secure.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2643">
                  Your Rights
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2644">
                  You have the right to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2645">
                  <li data-id="element-2646">Access your personal data</li>
                  <li data-id="element-2647">Correct inaccurate information</li>
                  <li data-id="element-2648">Request deletion of your data</li>
                  <li data-id="element-2649">Object to data processing</li>
                  <li data-id="element-2650">Request data portability</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2651">
                  Contact Us
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2652">
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                  <br data-id="element-2653" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2654">
                    hello@operines.ai
                  </a>
                </p>
              </>}
          </div>
        </motion.div>
      </div>
    </div>;
}